module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_wrapper"
  }, [_c('div', {
    staticClass: "container bottom-inner"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "button button1",
    class: {
      active: _vm.index === 0
    },
    on: {
      "click": function($event) {
        _vm.reloadIndex()
      }
    }
  }, [_c('div', {
    staticClass: "iconfont icon-browser"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "button button2",
    class: {
      active: _vm.index === 1
    },
    on: {
      "click": _vm.createPost
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("上传病例")])]), _vm._v(" "), _c('div', {
    staticClass: "button button3",
    class: {
      active: _vm.index === 2
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'me'
        })
      }
    }
  }, [_c('div', {
    staticClass: "iconfont icon-wode"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("我的")])])])]), _vm._v(" "), _c('div', {
    staticClass: "iphone-x-block"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-big-plus"
  }, [_c('div', {
    staticClass: "inner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0db7c5c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomBar.vue
// module id = 77
// module chunks = 1